import {
  CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION,
  CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS,
  CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE,
  CONFIRMED_GET_REPEAT_PRESCRIPTIONS
  // other imports...
} from '../actions/ServiceCallerPrescriptionType';

const initialState = {
  serviceCallerPrescriptions: [],
  patientDetails: null,
  markPrescriptionStatus: null,
  repeatPrescriptions: [],
  // other state...
};

export default function prescriptionReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION: {
      return {
        ...state,
        serviceCallerPrescriptions: action.payload,
      };
    }
    case CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS:
      return {
        ...state,
        patientDetails: action.payload,
      };
    case CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE:
      return {
        ...state,
        markPrescriptionStatus: action.payload,
      };

    case CONFIRMED_GET_REPEAT_PRESCRIPTIONS:
      return {
        ...state,
        repeatPrescriptions: action.payload,
      };

    // other cases...

    default:
      return state;
  }
}
